<template>
  <div class="container pad-btm15">
    <template v-if="!getIsShowRemindBtn">
      <van-sticky>
        <div class="subTitle">
          <div class="subLeftPart">
            <span class="iconfont icon-shoucang2"></span>
            收藏夹（{{ favoriteTotalCount || 0 }}）
          </div>
          <div class="btnText tapActive" @click="SET_MANAGEBTN_IS_OPEN(!getManageBtnIsOpen)">
            {{ getManageBtnIsOpen ? '完成' : '管理' }}
          </div>
        </div>
        <div class="switch-btn-box">
          <div class="leftPart">
            <div
              :class="{
                filterItem: true,
                filterItemSpecial: item.text.length < 3,
                active: H5FavoriteSearchType === item.type
              }"
              v-for="(item, index) in H5FavoriteSearchTypeList"
              :key="index"
              v-text="item.text"
              @click="switchType(item.type)"
            ></div>
          </div>
          <div class="hasStockBox" @click="switchTab">
            <div class="text"><span class="iconfont icon-wancheng" :class="{ active: this.hasStock }"></span>有库存优先</div>
          </div>
        </div>
      </van-sticky>
      <div style="width: 100%; height: 10px"></div>
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
        <collection-list :data-list="dataList" :is-newcomer="isNewcomer" @buyNow="buyNow" @deleteGoods="deleteGoods" @entoDetailPage="buyNow" @shareClick="shareClick"> </collection-list>
        <invalid-goods-list v-if="invalidDataList.length > 0" :dataList="invalidDataList" @deleteInvalid="deleteInvalid"> </invalid-goods-list>
      </div>
      <segement-line v-if="!haveMore" line-text="没有更多商品啦"> </segement-line>
      <segement-line v-if="haveMore" line-text="正在加载" :is-load="true"> </segement-line>
      <!-- 返回顶部 -->
      <quick-top @returnTop="returnTop" :isReturn="isReturn" :positionBtm="120"></quick-top>
      <div class="emptyBox" style="width: 100%; height: 50px"></div>
      <!-- 管理收藏夹底部按钮 -->
      <div class="controlBox" v-show="getManageBtnIsOpen">
        <div class="topPart">已选<span v-text="chooseProductIds.length"></span>件商品</div>
        <div class="bottomPart">
          <van-checkbox v-model="allChoosedIsOpen" @click="allChoosed">
            <span class="allChoosed" ref="allChoosedBtn">全选</span>
          </van-checkbox>
          <button :class="chooseProductIds.length ? 'del' : 'del unchooseDel'" @click="oneClickDelete()" :disabled="!chooseProductIds.length">一键删除</button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="isAppMode">
        <van-tabs v-model="active" @change="changeTab">
          <van-tab :title="'收藏夹（' + favoriteTotalCount + '）'">
            <div class="switch-btn-box">
              <div class="leftPart">
                <div
                  :class="{
                    filterItem: true,
                    filterItemSpecial: item.text.length < 3,
                    active: H5FavoriteSearchType === item.type
                  }"
                  v-for="(item, index) in H5FavoriteSearchTypeList"
                  :key="index"
                  v-text="item.text"
                  @click="switchType(item.type)"
                ></div>
              </div>
              <div class="hasStockBox" @click="switchTab">
                <div class="text"><span class="iconfont icon-wancheng" :class="{ active: this.hasStock }"></span>有库存优先</div>
              </div>
            </div>
            <div class="subTitle">
              <div class="subLeftPart"></div>
              <div class="btnText tapActive" @click="SET_MANAGEBTN_IS_OPEN(!getManageBtnIsOpen)">
                {{ getManageBtnIsOpen ? '完成' : '管理' }}
              </div>
            </div>
            <div style="width: 100%; height: 10px"></div>
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
              <collection-list
                :data-list="dataList"
                :is-newcomer="isNewcomer"
                @buyNow="buyNow"
                @deleteGoods="deleteGoods"
                @entoDetailPage="buyNow"
                @shareClick="shareClick"
                @remindBtnHandler="remindBtnHandler"
              >
              </collection-list>
              <invalid-goods-list v-if="invalidDataList.length > 0" :dataList="invalidDataList" @deleteInvalid="deleteInvalid"> </invalid-goods-list>
            </div>
            <segement-line v-if="!haveMore" line-text="没有更多商品啦"> </segement-line>
            <segement-line v-if="haveMore" line-text="正在加载" :is-load="true"> </segement-line>
            <!-- 返回顶部 -->
            <quick-top @returnTop="returnTop" :isReturn="isReturn" :positionBtm="120"></quick-top>
            <div class="emptyBox" style="width: 100%; height: 50px"></div>
            <!-- 管理收藏夹底部按钮 -->
            <div class="controlBox" v-show="getManageBtnIsOpen">
              <div class="topPart">已选<span v-text="chooseProductIds.length"></span>件商品</div>
              <div class="bottomPart">
                <van-checkbox v-model="allChoosedIsOpen" @click="allChoosed">
                  <span class="allChoosed" ref="allChoosedBtn">全选</span>
                </van-checkbox>
                <button :class="chooseProductIds.length ? 'del' : 'del unchooseDel'" @click="oneClickDelete()" :disabled="!chooseProductIds.length">一键删除</button>
              </div>
            </div>
          </van-tab>
          <van-tab :title="'抢购提醒（' + PrePerchaseTimeToBeRemindedCount + '）'">
            <time-scrroll ref="timeScroll" :time-list="timeList" :time-index="currentTimeIndex" @timeScrollClick="timeScrollClick"> </time-scrroll>
            <div v-infinite-scroll="getProductPrePurchaseRemindList" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
              <remind-list :is-newcomer="isNewcomer" :data-list="getProductPremangeRemindListParams.list" @entoDetailPage="buyNow" @shareClick="shareClick" @remindBtnHandler="remindBtnHandler">
              </remind-list>
            </div>
            <div class="no-more-goods" v-if="getProductPremangeRemindListParams.finished && getProductPremangeRemindListParams.list.length <= 0">
              <div class="no-more-img">
                <img src="@/assets/image/superman.png" alt="暂无商品" />
              </div>
              <p>还未添加商品提醒，</p>
              <p>先去逛逛吧~</p>
            </div>
            <template v-else>
              <segement-line v-if="getProductPremangeRemindListParams.finished" line-text="没有更多商品啦"> </segement-line>
              <segement-line v-if="getProductPremangeRemindListParams.loading" line-text="正在加载" :is-load="true"> </segement-line>
            </template>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 抢购时间节点弹窗 app-->
      <time-node-dialog
        v-if="isShowTimeNodeDialogOfApp"
        :node-data="currentNodeData"
        show-type="timeNode"
        tip="商品会在下列时间节点补货，请选择想收到抢购提醒的时间："
        sure-btn-text="确认设置"
        @onConfirm="timeNodeDialogConfirmHandler"
        @onCancel="isShowTimeNodeDialogOfApp = false"
      ></time-node-dialog>
    </template>
  </div>
</template>

<script>
import handleSubmitErr from '@/mixins/handleSubmitErr'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CollectionList from './children/CollectionList'
import InvalidGoodsList from './children/InvalidGoodsList'
import SegementLine from '@/components/puppetComponent/SegementLine'
import QuickTop from '@/components/smartComponent/QuickTop'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { GetProductFavoriteList, DeleteProductFavorite, GetProductFavoriteInvalidList, InvalidProductFavoriteRemove } from '@/api/remind'
import Utils from '@/utils/base'
import { Sticky, Checkbox, Tab, Tabs } from 'vant'
import remind from './mixins/remind.js'
import setRemind from '@/mixins/setRemind'

export default {
  mixins: [handleSubmitErr, remind, setRemind],
  data() {
    return {
      dataList: [],
      collectionLast: false, // 夹未失效商品是否有数据了
      invalidDataList: [],
      isLastOne: false,
      haveMore: true,
      isReturn: false,
      scrollDisabled: false,
      container: null,
      pageScrollTop: 0,
      favoriteTotalCount: 0,
      isNewcomer: false, // 是否是新人
      // 是否有库存参数字段
      hasStock: true,
      H5FavoriteSearchType: 1, // 全部 = 0, 仅看可购买 = 1, 仅看无法购买 = 2
      H5FavoriteSearchTypeList: [
        {
          type: 0,
          text: '全部'
        },
        {
          type: 1,
          text: '仅看可购买'
        },
        {
          type: 2,
          text: '仅看无法购买'
        }
      ],
      allChoosedIsOpen: false // 全选开关是否开启
    }
  },
  components: {
    CollectionList,
    InvalidGoodsList,
    SegementLine,
    QuickTop,
    'van-sticky': Sticky,
    'van-checkbox': Checkbox,
    'van-tabs': Tabs,
    'van-tab': Tab
  },
  computed: {
    ...mapGetters(['getManageBtnIsOpen', 'getAllChooseBtnSwitchInfo', 'getAllListInfoStatus', 'chooseProductIds', 'getIsShowRemindBtn'])
  },
  watch: {
    getAllListInfoStatus: {
      handler(val) {
        this.allChoosedIsOpen = val
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.container = document.getElementsByClassName('container')[0]
      this.container.addEventListener('scroll', this.handleScroll)
    })
  },
  beforeDestroy() {
    this.container.removeEventListener('scroll', this.handleScroll)
    this.container = null
  },
  methods: {
    ...mapMutations(['SET_MANAGEBTN_IS_OPEN', 'SET_ALL_CHOOSE_BTN_SWITCH_INFO']),
    ...mapMutations([
      'SET_INEFFECTIVE_LIST_INFO',
      'SET_EFFECTIVE_GOODS_LIST_INFO',
      'SET_MANAGEBTN_IS_OPEN',
      'SET_ALL_CHOOSE_BTN_SWITCH_INFO',
      'SET_IF_SHOW_APP_DOWNLOAD_GUIDE',
      'SET_IF_SHOW_APP_RESERVE_REMIND'
    ]),
    ...mapActions(['getIsBuy', 'resetCollectionClipData', 'delBtnEvent']),
    reFetchPage() {
      this.isNewcomer = Utils.getNewcomerStorage()
      this.dataList = []
      this.dataList.splice(0)
      this.invalidDataList = []
      this.invalidDataList.splice(0)
      this.pageScrollTop = 0
      this.isReturn = false
      this.currentTab = 1
      this.hasStock = true
      this.fetchData()
    },
    fetchData(isDropDown = false) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      return GetProductFavoriteList({
        H5FavoriteSearchType: this.H5FavoriteSearchType,
        HasStock: this.hasStock,
        IsDropDown: isDropDown
      })
        .then((res) => {
          const { DataList, IsLastRecord, FavoriteTotalCount, PrePerchaseTimeToBeRemindedCount, IfShowAppDownloadGuide, IfShowAppReserveRemind } = res
          this.SET_IF_SHOW_APP_DOWNLOAD_GUIDE(IfShowAppDownloadGuide)
          this.SET_IF_SHOW_APP_RESERVE_REMIND(IfShowAppReserveRemind)
          this.dataList = [...this.dataList, ...DataList]
          this.favoriteTotalCount = FavoriteTotalCount
          this.PrePerchaseTimeToBeRemindedCount = PrePerchaseTimeToBeRemindedCount
          this.isLastOne = IsLastRecord
          if (IsLastRecord) {
            this.haveMore = false
            this.collectionLast = true
            if (this.H5FavoriteSearchType !== 1) {
              this.fetchInvalidData()
            } else {
              Indicator.close()
            }
          } else {
            Indicator.close()
            this.haveMore = true
            this.collectionLast = false
          }
          this.scrollDisabled = false
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    // 获取失效商品
    fetchInvalidData(isDropDown = false) {
      if (isDropDown) {
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
      }
      this.scrollDisabled = true
      return GetProductFavoriteInvalidList({
        HasStock: this.hasStock,
        IsDropDown: isDropDown
      })
        .then((res) => {
          Indicator.close()
          this.isLastOne = res.IsLastRecord
          this.invalidDataList = [...this.invalidDataList, ...res.DataList]
          if (res.IsLastRecord) this.haveMore = false
          else this.haveMore = true
          this.scrollDisabled = false
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    switchTab() {
      this.resetCollectionClipData()
      this.IsLastRecord = false
      this.dataList = []
      this.invalidDataList = []
      this.hasStock = !this.hasStock
      this.fetchData()
    },
    switchType(val) {
      this.resetCollectionClipData()
      if (this.H5FavoriteSearchType === val) return
      this.H5FavoriteSearchType = val
      this.IsLastRecord = false
      this.dataList = []
      this.invalidDataList = []
      this.fetchData()
    },
    // 立即抢购
    async buyNow(productID, isFreeCard) {
      try {
        let isBuy = await this.getIsBuy(productID)
        if (isBuy) {
          this.$router.push({
            name: 'goodsDetail',
            query: {
              productID: productID,
              isFreeCard: isFreeCard
            }
          })
        }
      } catch (error) {
        this.handleSubmitErr(error, productID)
      }
    },
    // 分享好友
    shareClick(productId) {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          type: 'goods',
          productId: productId,
          pageType: 11
        }
      })
    },
    // 删除商品
    deleteGoods(productId) {
      MessageBox({
        title: '提示',
        message: '确认删除收藏吗？',
        showCancelButton: true,
        cancelButtonText: '我再想想',
        confirmButtonText: '删除',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') this.delGoodsReq(productId)
      })
    },
    delGoodsReq(productId, type) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      DeleteProductFavorite({ productId: productId })
        .then((res) => {
          Indicator.close()
          // this.invalidDataList = []
          if (type === 'invalid') {
            // this.fetchInvalidData()
            this.deleteItem(productId, this.invalidDataList)
            this.favoriteTotalCount = --this.favoriteTotalCount
            Toast('已移出失效商品')
          } else {
            // this.dataList = []
            // this.fetchData()
            this.deleteItem(productId, this.dataList)
            this.favoriteTotalCount = --this.favoriteTotalCount
            Toast('已移出收藏夹')
          }
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
            this.reFetchPage()
          }
        })
    },
    // 清空失效商品
    deleteInvalidAll() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      InvalidProductFavoriteRemove()
        .then((res) => {
          Indicator.close()
          this.dataList = []
          this.invalidDataList = []
          this.fetchData()
        })
        .catch((err) => {
          Indicator.close()
          if (err.ErrMsg) {
            Toast(err.ErrMsg)
          }
        })
    },
    // 列表时间节点排序
    timeNodeCompare(dataList) {
      if (!dataList || dataList.length <= 0) return
      dataList.sort((a, b) => {
        let bNodeTime = b.Node.replace(/(\d{1,2})+[:：](\d*)/gi, '$1')
        let aNodeTime = a.Node.replace(/(\d{1,2})+[:：](\d*)/gi, '$1')
        if (a.GapDay === b.GapDay) {
          return Number(aNodeTime) - Number(bNodeTime)
        } else {
          return a.GapDay - b.GapDay
        }
      })
    },
    // 删除失效商品
    deleteInvalid(type, productId) {
      let msg = '确认删除收藏吗？'
      if (type === 'all') msg = '确认清空失效商品吗？'
      MessageBox({
        title: '提示',
        message: msg,
        showCancelButton: true,
        cancelButtonText: '我再想想',
        confirmButtonText: type === 'all' ? '清空' : '删除',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          if (type === 'all') {
            this.deleteInvalidAll()
          } else {
            this.delGoodsReq(productId, 'invalid')
          }
        }
      })
    },
    // 返回顶部
    returnTop() {
      this.container.scrollTop = 0
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop
      this.pageScrollTop = scrollTop
      // 屏幕高度
      let documentH = document.documentElement.clientHeight || document.body.clientHeight
      if (scrollTop > documentH) {
        this.isReturn = true
      } else {
        this.isReturn = false
      }
    },
    loadMore() {
      if (this.isLastOne) {
        this.haveMore = false
        return
      }
      this.haveMore = true
      if (this.collectionLast) return this.fetchInvalidData(true)
      else return this.fetchData(true)
    },
    // 删除数组中指定的一个数据
    deleteItem(productId, list) {
      // 先遍历list里面的每一个元素，对比item与每个元素的id是否相等，再利用splice的方法删除
      for (var key in list) {
        if (list[key].ProductId === productId) {
          list.splice(key, 1)
        }
      }
    },
    allChoosed() {
      this.SET_ALL_CHOOSE_BTN_SWITCH_INFO({
        allChoosedIsOpen: !this.getAllListInfoStatus,
        allChoosedChangeNeedResetData: true
      })
    },
    // 一键删除
    oneClickDelete() {
      this.delBtnEvent({
        callback: async (chooseProductIds) => {
          // 标记删除前是否为全选状态
          let flag = this.allChoosedIsOpen
          // 根据商品id删除数组中的数据
          this.dataList = this.dataList.filter((val) => {
            return chooseProductIds.indexOf(val.ProductId) < 0
          })
          this.invalidDataList = this.invalidDataList.filter((val) => {
            return chooseProductIds.indexOf(val.ProductId) < 0
          })
          await this.loadMore()
          if (this.H5FavoriteSearchType === 1 && this.dataList.length === 0) {
            // 仅看可购买情况且数据为空
            this.resetCollectionClipData()
            this.reFetchPage()
          } else if (this.dataList.length === 0 && this.invalidDataList.length === 0) {
            // 非近看只购买情况且两种数据都为空
            this.resetCollectionClipData()
            this.reFetchPage()
          } else if (flag) {
            this.$refs.allChoosedBtn.click()
          }
        },
        errorHander: () => {
          this.resetCollectionClipData(true)
          this.reFetchPage()
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'goodsDetail' && vm.container) {
        vm.$nextTick(() => {
          vm.container.scrollTop = vm.pageScrollTop || 0
        })
        return
      }
      // if (vm.getIsApp) {
      //   vm.active = 0
      //   vm.isAppReFetchPage(from)
      // } else {
      //   vm.reFetchPage(from)
      // }
      vm.isAppReFetchPage(from)
    })
  },
  beforeRouteLeave(to, from, next) {
    this.resetCollectionClipData()
    next()
  }
}
</script>

<style scoped lang="scss">
.isAppMode {
  .subTitle {
    padding: 0 3% 10px;
    .btnText {
      line-height: 1em;
    }
  }
  .switch-btn-box {
    padding: 16px 3%;
  }
}
.filterItem {
  min-width: 80px;
}
.subTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px 3% 10px;
  background-color: #fff;
  .subLeftPart {
    font-size: 15px;
    font-weight: 700;
    .iconfont {
      color: #e6161e;
    }
  }
}
.controlBox {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 3%;
  position: fixed;
  bottom: 57px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 10px 0 hsla(0, 2%, 75%, 0.5);
  .topPart {
    display: flex;
    align-items: center;
    height: 40px;
    span {
      color: #ea4163;
      margin: 0 2px;
    }
  }
  .bottomPart {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // height: 50px;
    padding-bottom: 10px;
  }
  .del {
    width: 80px;
    line-height: 22px;
    text-align: center;
    color: #f23030;
    background: #fff;
    border: 1px solid #f23030;
    padding: 2px 0;
    margin-left: 5px;
    border-radius: 15px;
  }
  .unchooseDel {
    color: #b2b4b6;
    border: 1px solid #b2b4b6;
  }
}
.remind-dialog-text {
  padding-bottom: 20px;
  font-size: 14px;
  line-height: 20px;
}
.switch-btn-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* height: 30px; */
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  color: #888;
  background-color: #fff;
  padding: 10px 3%;
  box-sizing: border-box;
  overflow-x: scroll;
  /* margin-bottom: 10px; */
  .leftPart {
    display: flex;
    align-items: center;
  }
}
.switch-btn {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  margin-left: 10px;
  transition: all 0.2s ease-in;
}
.switch-btn.active {
  background: #fff;
  color: #f23030;
}
.hasStockBox {
  display: flex;
  align-items: center;
  font-size: 12px;
  flex-shrink: 0;
  margin-left: 20px;
  .iconfont {
    font-size: 12px;
    margin-right: 4px;
    &.active {
      color: #f05c61;
    }
  }
  .text {
  }
}

.no-more-goods {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #999;
  margin-top: 30%;
}
.no-more-img {
  width: 100px;
  height: 100px;
}
.no-more-img img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
